import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
      width: 250px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  align-items: center;
  margin-top: 10px;
  max-width: 1180px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 0 10px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 340px;
    margin: 24px auto 0;
    padding: 0;
    gap: 20px;
  }
`;

export const TextBox1 = styled.div`
  flex: 1;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 20px;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  p {
    color: #e4e4e4;
    font-size: 48px;
    font-style: normal;
    font-weight: 200;
    line-height: 56px;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 32px;
    }
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  padding: 10px;
  color: #c3c3c3;

  @media (max-width: 768px) {
    padding: 0;
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;
    padding: 0 40px;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
      padding: 0;
    }
  }

  .link-with-icon {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: #f16024;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    @media (max-width: 768px) {
      font-size: 16px;
      width: 350px;
      padding-left: 10px;
    }
  }

  .link-with-icon img {
    width: 20px;
    height: 20px;
  }
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
  }
`;
